import styled, { css } from 'styled-components';
import { Typography } from '../Typography/Typography.styled';
import { TInputFieldStylesApplied } from './InputField';

export const InputContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['stylesApplied'].includes(prop),
})<{
  stylesApplied: TInputFieldStylesApplied;
}>`
  ${({ stylesApplied }) =>
    stylesApplied === 'loginInput' &&
    css`
      box-sizing: border-box;
      position: relative;

      ${Typography} {
        position: absolute;
        top: 50%;
        left: var(--spacing-component-inner);
        transform: translateY(-50%);
        transition: transform 0.3s;
        transform-origin: left;
      }
    `}
`;

export const FormInput = styled.input.withConfig({
  shouldForwardProp: (prop) => !['isEmpty', 'stylesApplied'].includes(prop),
})<{
  isEmpty: boolean;
  stylesApplied: TInputFieldStylesApplied;
}>`
  box-sizing: border-box;
  
  &:-webkit-autofill {
    appearance: none;
    -webkit-appearance: none;
  }

  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    box-shadow: 0 0 0 1000px white inset !important;
    -webkit-text-fill-color: #000 !important;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000000s ease-in-out 0s;
}

  &:-webkit-autofill {
    /* override background */
    box-shadow: 0 0 0 1000px white inset !important;

    /* override text color */
    -webkit-text-fill-color: #000 !important;

    /* optionally, remove border */
    border: 1px solid #ccc !important;

    /* helps reduce animation flicker */
    transition: background-color 5000s ease-in-out 0s;
  }

  ${({ stylesApplied, isEmpty }) =>
    stylesApplied === 'loginInput' &&
    css`
      height: var(--form-el-height);
      width: 100%;
      padding: 5% var(--spacing-component-inner) 0
        var(--spacing-component-inner);
      font-size: var(--font-size-lg);

      &:focus + ${Typography} {
        transform: translateY(-130%) scale(0.8);
      }

      ${!isEmpty &&
      css`
        & + ${Typography} {
          transform: translateY(-130%) scale(0.8);
        }
      `}
    `}
`;
